var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTweet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 40,
    height: 40,
    fill: "#CD63FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 10.6779C30.5 11.2495 29.3567 11.4817 28.1667 11.8329C26.8589 10.357 24.9199 10.2754 23.0567 10.973C21.1935 11.6707 19.9732 13.3764 20 15.3329V16.4995C16.2142 16.5964 12.8425 14.872 10.6667 11.8329C10.6667 11.8329 5.78771 20.5047 15.3334 24.6662C13.1494 26.121 10.9712 27.1022 8.33337 26.9995C12.1927 29.103 16.3985 29.8264 20.0397 28.7694C24.2164 27.556 27.6487 24.4259 28.9659 19.737C29.3588 18.311 29.5539 16.8377 29.5457 15.3585C29.5434 15.068 31.3074 12.1245 31.6667 10.6767V10.6779Z",
    stroke: "#CD63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweet);
export default __webpack_public_path__ + "static/media/tweet.f6ea4217.svg";
export { ForwardRef as ReactComponent };